export const GET_RELEASE_NOTES_REQUEST = "get_release_notes_request";
export const GET_RELEASE_NOTES_SUCCESSFUL = "get_release_notes_successful";
export const GET_RELEASE_NOTES_FAILED = "get_release_notes_failed";

export const GET_RELEASE_DETAILS_REQUEST = "get_release_details_request";
export const GET_RELEASE_DETAILS_SUCCESSFUL = "get_release_details_successful";
export const GET_RELEASE_DETAILS_FAILED = "get_release_details_failed";

export const CLEAR_ALL_RELEASE_MESSAGES = "clear_all_release_messages";
export const CLEAR_ALL_RELEASE_MESSAGES_SUCCESSFUL = "clear_all_release_messages_successful";